// Phase 2 worker-type enums + client-side helpers (mirror backend rules for UX).
export const WORKER_CATEGORIES = ["GERMAN", "EU_EEA_SWISS", "NON_EU", "NOT_CLASSIFIED"];
export const EMPLOYMENT_CONTEXTS = ["DIRECT_EMPLOYEE", "POSTED_WORKER", "SUBCONTRACTOR_WORKER"];
export const WORKER_LOCATIONS = ["IN_GERMANY", "ABROAD", "UNKNOWN"];
export const REGULATED_VALUES = ["YES", "NO", "UNKNOWN"];
export const RECOGNITION_STATUSES = ["NOT_REQUIRED", "NOT_STARTED", "IN_PROGRESS", "PARTIAL_RECOGNITION", "FULL_RECOGNITION", "REJECTED", "UNKNOWN"];

const GERMAN = new Set(["german", "deutsch", "deutschland", "germany", "de"]);
const EU = new Set([
  "austria", "österreich", "belgium", "belgien", "bulgaria", "bulgarien", "croatia", "kroatien",
  "cyprus", "zypern", "czech", "tschechien", "denmark", "dänemark", "estonia", "estland",
  "finland", "finnland", "france", "frankreich", "greece", "griechenland", "hungary", "ungarn",
  "ireland", "irland", "italy", "italien", "latvia", "lettland", "lithuania", "litauen",
  "luxembourg", "luxemburg", "malta", "netherlands", "niederlande", "poland", "polen",
  "portugal", "romania", "rumänien", "slovakia", "slowakei", "slovenia", "slowenien",
  "spain", "spanien", "sweden", "schweden", "norway", "norwegen", "iceland", "island",
  "liechtenstein", "switzerland", "schweiz", "eu", "ewr", "eea",
]);

export function suggestCategory(nationality) {
  if (!nationality) return "NOT_CLASSIFIED";
  const n = nationality.trim().toLowerCase();
  if (GERMAN.has(n)) return "GERMAN";
  if (EU.has(n)) return "EU_EEA_SWISS";
  return "NON_EU";
}

// Which dynamic sections apply — mirrors backend _worker_sections.
export function sectionsFor(w) {
  const cat = w.worker_category || "NOT_CLASSIFIED";
  const ctx = w.employment_context || "DIRECT_EMPLOYEE";
  const secs = new Set(["PERSONAL", "EMPLOYMENT"]);
  if (cat === "NON_EU") secs.add("RESIDENCE_WORK");
  if (ctx === "POSTED_WORKER") secs.add("POSTING");
  if (ctx === "SUBCONTRACTOR_WORKER") secs.add("SUBCONTRACTOR");
  if (w.regulated_profession === "YES") secs.add("RECOGNITION");
  if (w.worker_location_status === "ABROAD") secs.add("IMMIGRATION");
  return secs;
}
